// Drip Action: which of the agency's drips starts when a disposition is applied.
// A drip is "linked" when its dispositionTriggers name the disposition (any drip can be linked;
// a new-lead drip keeps starting on new leads too) (matched case-insensitively by label, slug or system code, exactly
// like the server's enrollInDrip).

export const normKey = (s) => String(s || '').trim().toLowerCase();

/** Every name this disposition can be matched by. */
export function dispositionKeys(disp) {
  return [disp?.label, disp?.slug, disp?.systemCode].map(normKey).filter(Boolean);
}

/** The drip currently linked to `disp`, or null. */
export function linkedDrip(drips = [], disp) {
  const keys = dispositionKeys(disp);
  return drips.find((d) => (d.dispositionTriggers || []).some((t) => keys.includes(normKey(t)))) || null;
}

/** Every drip can be linked to a disposition. */
export const canLink = () => true;

/** A drip with no real trigger becomes a disposition drip once linked; others keep their own trigger. */
export const needsDispositionTrigger = (drip) => !drip.trigger || drip.trigger === 'manual';

/** `drip`'s trigger list with this disposition removed. */
export function triggersWithout(drip, disp) {
  const keys = dispositionKeys(disp);
  return (drip.dispositionTriggers || []).filter((t) => !keys.includes(normKey(t)));
}

/** `drip`'s trigger list with this disposition added (label, plus system code when it has one). */
export function triggersWith(drip, disp) {
  const base = triggersWithout(drip, disp);
  return [...base, disp.label, ...(disp.systemCode ? [disp.systemCode] : [])].filter(Boolean);
}
